import { Difficulties } from '@/utils/enums/Difficulties';

export interface IContentResource {
  createdAt: string;
  id: string;
  lessonContentID: string;
  name: string;
  order: number;
  trackID: string;
  type: LessonContentResources;
  url: string;
}

export interface ILessonContent {
  contentResources: IContentResource[];
  description: string;
  difficultyLevel: Difficulties;
  duration: number;
  id: string;
  image: string;
  isActive: boolean;
  name: string;
}

export enum LessonContentResources {
  interactive = 'interactive',
  video = 'video',
  pdf = 'pdf',
  podcast = 'podcast',
  mindMap = 'mind_map',
  discover = 'discover',
  aiMaterial = 'ai_material',
  teachersGuide = 'teachers_guide',
}
